<template>
  <van-tabbar v-if="show" v-model="active" style="z-index:10" active-color="#7e5678" :border="true" inactive-color="#979799">
    <div class="van-tabbar" style="width: 100%;max-width: 500PX;margin: auto">

      <van-tabbar-item v-for="(k, key) in item" replace :to="k.router" :key="key">
        <span v-show="key !== 2">{{ $t(k.title) }}</span>
        <template #icon="props">
          <img :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title" v-show="key !== 2" />
          <img :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title" class="tui" style="height: 4rem;margin-top: -20px;" v-show="key === 2" />
        </template>
      </van-tabbar-item>
    </div>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      item: [
        {
          router: '/Home',
          title: "footer.home",
          icon: {
            active: '/img/footer/index.jpg',
            noactive: '/img/footer/index.jpg'
          }
        },

        {
          router: '/Game',
          title: "footer.game",
          icon: {
            active: '/img/footer/subscribe2.jpg',
            noactive: '/img/footer/subscribe2.jpg'
          }
        },
        {
          router: '/Choose',
          title: "text.choose",
          icon: {
            active: '/img/footer/beauty3.png',
            noactive: '/img/footer/beauty3.png'
          }
        },
        {
          router: '/Video',
          title: "footer.video",
          icon: {
            active: '/img/footer/video.jpg',
            noactive: '/img/footer/video.jpg'
          }
        },
        {
          router: '/Mine',
          title: "footer.mine",
          icon: {
            active: '/img/footer/my.jpg',
            noactive: '/img/footer/my.jpg'
          }
        }
      ]
    };
  },
  methods: {

  },
  watch: {
    $route(to) {
      if (to.name == 'home') {
        this.active = 0;
        this.show = true;
      } else if (to.name == 'game') {
        this.active = 3;
        this.show = true;
      } else if (to.name == 'choose') {
        this.active = 2;
        this.show = true;
      } else if (to.name == 'video') {
        this.active = 1;
        this.show = true;
      } else if (to.name == 'mine') {
        this.active = 4;
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  created() {

    if (this.$route.name == 'home') {
      this.active = 0;
      this.show = true;
    } else if (this.$route.name == 'game') {
      this.active = 3;
      this.show = true;
    } else if (this.$route.name == 'choose') {
      this.active = 2;
      this.show = true;
    } else if (this.$route.name == 'video') {
      this.active = 1;
      this.show = true;
    } else if (this.$route.name == 'mine') {
      this.active = 4;
      this.show = true;
    } else {
      this.show = false;
    }
  }
};
</script>